import { Injectable } from '@angular/core';
import * as _ from "lodash";

@Injectable({
  providedIn: 'root'
})
export class ArrayHelperService {

  public static unique(list: Array<any>, uniqueBy: string ) {
    return _.uniqBy(list, uniqueBy);
  }

  public static remove(origin: Array<any>, from: Array<any>, uniqBy: string) {
    return _.filter(origin, (el) => {

      let filter = {};
      filter[uniqBy] = _.get(el, uniqBy);

      return _.find(from, filter) === undefined;
    });
  }

  public static diff(origin: Array<any>, from: Array<any>, uniqBy: string) {
    //ne e testvano
    return _.filter(origin, (el) => {

      let filter = {};
      filter[uniqBy] = _.get(el, uniqBy);

      return _.find(from, filter) != undefined;
    });
  }
}
